<template>
  <div id="app">
    <!--导航条-->
    <gheader type="home"></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav type="home"></grednav>
    <div class="row-agreement">
      <div class="main-width">
        <div id="agreement">
          <h2 id="title">供应商操作手册</h2>
          <div id="source">
            <p></p>
          </div>
          <div id="content">

            <h4>一、供应商须知</h4>
            <p class="text-padding">尊敬的供应商：</p>
            <p class="text-padding">您好！</p>
            <p class="text-padding">目前{{companyName}}采购门户已经上线了网上招标采购系统，未来我们会把更多的采购信息都发布到系统中，期待您注册网上招采平台和我们长期合作。</p>
            <p class="text-padding">为了帮助您更好的了解和掌握此系统，我们编写的以下操作手册，希望能够帮到您。以后如果在使用过程中遇到问题，一定要记得及时联系我们哦。</p>

            <h4>二、供应商申请流程</h4>
            <h5>1.网上招采地址</h5>
            <p class="text-padding">请在浏览器中输入地址https://yc.yonyoucloud.com/{{context}} 登陆{{companyName}}采购门户。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_.png" alt="">
            </div>

            <h5>2.供应商注册</h5>
            <p class="text-padding">希望参加{{companyName}}采购招标的供应商需要在网上申请成为{{companyName}}的供应商。</p>
            <h6>2.1 开始注册</h6>
            <p class="text-padding">点击“供应商注册”按钮开始注册。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_1.png" alt="">
            </div>
            <h6>2.2 确认相关条款</h6>
            <p class="text-padding">同意并继续后开始填写相关资料</p>
            <div class="manual-img">
              <img src="static/imgs/manual_2.png" alt="">
            </div>
            <h6>2.3 填写账号信息</h6>
            <p class="text-padding">手机号：需要用手机号进行注册（一个手机号只能注册一个账号）</p>
            <p class="text-padding">账号：即登录采购门户进行报名，投标等操作的账号（账号必须是唯一的无法重复）</p>
            <p class="text-padding">密码：账户的密码</p>
            <p class="text-padding">企业名称：请确认是公司全称，注册后无法修改。</p>
            <p class="text-padding">相关信息填写完整后点击“下一步，完善供应商信息”系统会提示“您的账号已经注册成功”</p>
            <div class="manual-img">
              <img src="static/imgs/manual4.png" alt="">
            </div>
            <h6>2.4 完善供应商信息</h6>
            <p class="text-padding">完善供应商注册信息有两种方式，一种是继续完善供应商资料，另一种时登录账号继续完善相关资料。（两种方式选择一种即可）</p>
            <p class="text-padding">供应商名称：由上一步代入</p>
            <p class="text-padding">管理组织：即确定您提交的资料由哪一家公司审核。</p>
            <p class="text-padding">供应商资质信息：请选择是上传三证还是五证，并需要填写相关证件账号。</p>
            <p class="text-padding">供应品类：即您要申请的供货类别（请如实填写）</p>

            <p class="text-padding">2.4.1 继续完善资料</p>
            <p class="text-padding">相关资料填写完成后点击“提交采购商审核即可”。</p>
            <div class="manual-img">
              <img src="static/imgs/manual5.png" alt="">
            </div>
            <p class="text-padding">2.4.2 登录账号完善资料。</p>

            <p class="text-padding">2.4.2.1 返回采购门户，点击按钮“立即登录”。输入“账号”“密码”后登录。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_3.png" alt="">
            </div>
            <p class="text-padding">2.4.2.2 登录后点击“供应商申请”按钮填写供应商相关资料。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_9.png" alt="">
            </div>
            <p class="text-padding">
              同意相关条款后，直接到供应商资料填写页面，填写完相关资料后，提交采购商审核即可
            </p>

            <h5>三、查看供应商审核是否通过</h5>
            <h6>3.1 账号登录</h6>
            <p class="text-padding">登录供应商账号，登录后点击进入工作台。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_3.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual_5.png" alt="">
            </div>
            <h6>3.2 查看供应商申请界面</h6>
            <div class="manual-img">
              <img src="static/imgs/manual10.png" alt="">
            </div>
            <h6>3.3 查看审核是否通过</h6>
            <p class="text-padding">待审核状态可以查看相关供应商资料，申请被驳回后，可以修改相关资料重新提交，申请通过后可以参加{{companyName}}相关企业的采购招标。</p>
            <div class="manual-img">
              <img src="static/imgs/manual11.png" alt="">
            </div>
            <h4>三、供应商招标</h4>
            <h5>1.供应商报名</h5>
            <p class="text-padding">供应商报名分两种情况，一种是邀请报名，一种是直接报名。</p>
            <h6>1.1 邀请报名</h6>
            <p class="text-padding">直接登录账号即可，登录账户，进入工作台，投标管理，在报名中查看“待报名”的数量，点击“报名”按钮，填写相关资料报名即可。</p>
            <div class="manual-img">
              <img src="static/imgs/manual12.png" alt="">
            </div>
            <h6>1.2 直接报名</h6>
            <p class="text-padding">在{{companyName}}招采门户，查询招标信息，点击相关招标信息，点击我要报名，然后登录后，点击报名，填写相关资料后，点击“报名”即可</p>
            <div class="manual-img">
              <img src="static/imgs/manual_6.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual14.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual_7.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual16.png" alt="">
            </div>
            <h5>2.供应商招标</h5>
            <h6>2.1 供应商投标</h6>
            <p class="text-padding">
              登录账号如果在招标管理，在待投标里可以看到可以投标的数量，上传附件，输入报价，点击“保存”“投标”按钮即可。采购商如果对报价不满意，可以发起谈判，然后供应商可以在“待投标”进行报价。</p>
            <div class="manual-img">
              <img src="static/imgs/manual17.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual18.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual19.png" alt="">
            </div>
            <h5>3.中标通知</h5>
            <p class="text-padding">中标后供应商账号和招标门户都会收到中标通知。</p>
            <div class="manual-img">
              <img src="static/imgs/manual20.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual_8.png" alt="">
            </div>
            <h4>四、供应商上架商品到采购商云采超市</h4>
            <p class="text-padding">供应商要将自己的商品上架到采购商的云采超市里，可以通过两种方式进行。一种是通过发送“允销申请”，一种是通过与采购商已发生的销售合同发布合同商品清单。</p>
            <h5>1.发送“允销申请”</h5>
            <h6>1.1维护“商品分类”</h6>
            <p class="text-padding">添加商品前先添加商品分类，后续再进行商品管理时进行对应。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_21.png" alt="">
            </div>
            <h6>1.2维护“商品管理”</h6>
            <p class="text-padding">将自己要进行上架的商品在“商品管理”进行维护。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_22.png" alt="">
            </div>
            <p class="text-padding">完善维护好商品信息后进行发布。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_23.png" alt="">
            </div>
            <p class="text-padding">将新添加的商品进行上架，这里的“上架”是指供应商将商品的状态变为“销售中”。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_24.png" alt="">
            </div>
            <h6>1.3发送“允销申请”</h6>
            <p class="text-padding">供应商将自己销售状态的商品通过“允销申请”发送给采购商，采购商通过此申请后可将对应的商品上架到采购商的云采超市，方便采购商直接通过超市下单商品。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_25.png" alt="">
            </div>
            <p class="text-padding">维护允销申请信息。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_26.png" alt="">
            </div>
            <p class="text-padding">提交发送“允销申请”。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_27.png" alt="">
            </div>
            <p class="text-padding">申请提交后，状态会到“待确认”；采购商确认后，状态会到“已确认”；采购商驳回后，状态会到“被驳回”，驳回后的申请可进行修改后再提交。</p>
            <h5>2.发送“合同商品清单”</h5>
            <h6>2.1发布商品清单</h6>
            <p class="text-padding">供应商将已确认已生效的销售合同在“查看详情”里点击“商品清单管理”，然后进行“发布商品清单”。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_28.png" alt="">
            </div>
            <h6>2.2查看清单状态</h6>
            <p class="text-padding">发布后，可在“合同管理-合同清单管理”查看状态，“待提交”指还未发布商品清单给采购商，当前只是一个保存状态；“已提交”指已将清单发布给采购商，当前采购商还未确认；“已确认”指采购商已将此清单进行确认，当前清单里的商品已获得采购商同意上架到采购商的云采超市。</p>
            <div class="manual-img">
              <img src="static/imgs/manual_29.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import {apiLinks} from '../../api/links.js'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav
    },
    data () {
      return {
        companyName: apiLinks.companyname,
        context: apiLinks.context
      }
    },
    methods: {
      enterlink: function () {
        let str = window.location.href
        let array = str.split('?')
        if (array[1] === 'register') {
          window.location.href = apiLinks.register
        } else if (array[1] === 'applyFor') {
          window.location.href = apiLinks.suppliersFor
        }
      }
    }
  }
</script>
<style>
  #agreement {
    width: 980px;
    min-height: 650px;
    margin: 50px auto;
    box-shadow: 0 2px 6px #999;
    _border: 1px #dedede solid;
    padding: 15px;
  }

  #title {
    text-align: center !important;
    font-size: 26px;
    font-weight: 400;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  #source > p {
    width: 950px;
    margin: 0 auto;
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 20px;
    color: #999;
    line-height: 30px;
    padding-bottom: 5px;
    text-align: center;
  }

  #content > p {
    font-size: 12px;
    font-family: "Microsoft YaHei", Arial, Verdana, sans-serif;
    background: #ffffff;
    color: #333;
    margin: 0 0 10px;
    line-height: 30px;
  }

  .manual-img {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }

  .manual-img > img {
    width: 800px;
  }

  .text-padding {
    padding-left: 24px;
    padding-right: 24px;
  }

  #content h5, #content h6 {
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 20px;
  }

  #content h4 {
    margin-top: 20px;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// manual.vue?117fb9bf